import React, { useState, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

const TopCouponsForm = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState('');
  const fileInputRef = useRef(null);
  const [amount, setAmount] = useState('');
  const [mobile, setMobile] = useState('');
  const [position,setPosition] = useState(selectedOption)
  const navigate = useNavigate();

  const TopCouponsUpload = async (e) => {
    e.preventDefault();

    if (!image || !selectedOption || !url) {
      alert('Please select an image, type, and enter a URL.');
      return;
    }

    const formData = new FormData();
    formData.append('Data', image); // ✅ matches backend DTO
    formData.append('postion', selectedOption); // ✅ fixed typo
    formData.append('MerchantURL', url); // ✅ using actual URL field

    // Debug: log the form data
    // for (let [key, value] of formData.entries()) {
    //   console.log(key, value);
    // }

    try {
      const res = await axios.post(
        `https://api.bakpoket.com/api/TopBanner/TTC_Images`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      alert('Image uploaded successfully!');
      // console.log('Response:', res.data);

      // Clear inputs
      setImage(null);
      setSelectedOption('');
      setUrl('');
      if (fileInputRef.current) fileInputRef.current.value = null;

    } catch (err) {
      console.error('Upload error:', err);
      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Error response:', err.response.data);
        alert(`Upload failed: ${JSON.stringify(err.response.data)}`);
      } else {
        alert('Upload failed.');
      }
    }
  };

  const handlePayment = (e) => {
    e.preventDefault();

    if (!amount || !mobile) {
      alert('Please enter amount and mobile number');
      return;
    }

    navigate('/payment', {
      state: {
        amount,
        mobile,
        position,
      },
    });
  };

  return (
    <Card>
      <h2 className='text-center text-md-start pt-2 pt-md-0'>Top Coupons Images</h2>
      <form onSubmit={TopCouponsUpload}>
        <select
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option value="">-- Select --</option>
          <option value="TTCoLeftMin">TTCO-left-min</option>
          <option value="TTCoMax">TTCO-max</option>
          <option value="TTCoRightMin">TTCO-right-min</option>
        </select>

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={(e) => setImage(e.target.files[0])}
        />

        <input
          type="text"
          placeholder="Enter Website URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />

        <button type="submit">Submit</button>
      </form>

      <hr />

      <h2 className='text-center text-md-start'>Payment</h2>
      <form onSubmit={handlePayment}> {/* ✅ Hook into custom handler */}
        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <input
          type="number"
          placeholder="Mobile"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />
        <button type="submit">Payment</button>
      </form>
    </Card>
  );
};

export default TopCouponsForm;


// const Card = styled.div`
//   background-color: white;
//   padding: 30px;
//   border-radius: 12px;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
//   max-width: 400px;
//   width: 100%;

//   h2 {
//     font-size: 22px;
//     margin-bottom: 20px;
//     color: #2a4157;
//   }

//   form {
//     display: flex;
//     flex-direction: column;
//     gap: 15px;

//     input[type="file"] {
//       padding: 10px;
//       border: 1px solid #ccc;
//       border-radius: 6px;
//     }

//     select,
//       input[type='file'],
//       button {
//         padding: 8px;
//         border-radius: 5px;
//       }

//     button {
//       padding: 10px 15px;
//       background-color: #ef4766;
//       border: none;
//       color: white;
//       border-radius: 6px;
//       cursor: pointer;
//       font-weight: 600;
//       transition: background 0.3s;

//       &:hover {
//         background-color: #d63c5b;
//       }
//     }
//   }

//   @media (max-width: 768px) {
//     max-width: 220px;
//     width: 85%;
//     padding: 5px;

//     h2 {
//       font-size: 13px;
//     }

//     button {
//       font-size: 10px;
//       padding: 8px 12px;
//     }

//     input[type="file"] {
//       padding: 6px;
//       border: 1px solid #ccc;
//       border-radius: 6px;
//       font-size:11px;
//     }
//   }
// `;


const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  height:auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input[type="file"],input[type="text"],input[type="number"],select  {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 5px;

    h2 {
      font-size: 13px;
      
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }

    input[type="file"],input[type="text"],input[type="number"],select {
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size:11px;
    }
  }

  @media (max-width: 576px) {
    h2 {
      margin-bottom:5px;
    }

    form {
        gap: 5px;
    }

    hr{
      margin:5px;
    }
  }
`;


const TableWrapper = styled.div`
  margin-top: 20px;
  overflow-x: auto;

  h3 {
    color: #2a4157;
    font-size: 18px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 13px;
      margin-bottom: 7px;
    }

    table {
    width: 100%;
    font-size: 7px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 2px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }
  }
`;